export default class ContentSourceService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getContentSourceContentChannel(id, params){
		return this.apiService.callGet('content_source_contents/'+id, params)
	}

	deleteEntity(params) {
		return this.apiService.callDelete('content_source_contents', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/ContentSourceContentService.js